import { createMemoryNetwork } from "./memory";
import { createNodeNetwork } from "./node";
import { createWebNetwork } from "./web";

export const Network = {
  memory: createMemoryNetwork,
  node: createNodeNetwork,
  web: createWebNetwork,
}